import React from "react";

import { Switcher as SharedSwitcher } from "@sportal/cdk";

import "./Switcher.scss";

export const Switcher = (props) => <SharedSwitcher {...props} />;
